/* eslint-disable @typescript-eslint/no-unused-vars */
import { Address, AmicAddress } from './components/types';

export const makeAddressString = (
  address: Omit<Address, 'owner' | 'ownerId' | 'id'> | AmicAddress,
) => {
  if (!address) return '';

  const { __typename, id, coordinates, ...rest } = address as any;
  return Object.values(rest).join(' ');
};
